var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{staticClass:"chat-modal-container",attrs:{"vanilla":true,"show":_vm.activeQuestionId !== 0,"size":_vm.modalSize.Chat,"border-radius":8,"flex":true,"allow-escape":false,"allow-click-out":true,"has-close":true,"close":_vm.onCloseModal}},[_c('Chat',{attrs:{"reply-call-back":_vm.replyCallBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }